import { stepColor } from '../lib/stepColors';

// The signature device: a circled step number that carries the step's color.
// The number is always present, so color is never the only signal.
export function StepBadge({
  n,
  size = 'md',
}: {
  n: number;
  size?: 'sm' | 'md' | 'lg';
}) {
  const c = stepColor(n);
  const px = size === 'sm' ? 'h-[1.15rem] w-[1.15rem] text-[0.68rem]' : size === 'md' ? 'h-6 w-6 text-[0.8rem]' : 'h-10 w-10 text-lg';
  return (
    <span
      role="img"
      aria-label={`step ${n}`}
      className={`inline-flex shrink-0 items-center justify-center rounded-full border-2 font-sans font-semibold tabular-nums ${px}`}
      style={{ backgroundColor: c.tint, borderColor: c.base, color: c.deep }}
    >
      {n}
    </span>
  );
}
